import { isWebview } from '@elparking/utils'
import { useRef, useEffect } from 'react'
import { trackTealiumEvent } from 'commons/js/services/analytics'

function useOnCloseModalAnalyticEvent (showModal, event) {
  const firstTime = useRef(true)

  useEffect(() => {
    if (!firstTime.current && isWebview() && !showModal) {
      trackTealiumEvent(event)
    }
    firstTime.current = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])
  }
  export default useOnCloseModalAnalyticEvent
